import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from './dateTimeFormats'
import zh from './locales/zh-CN'
import en from './locales/en-US'
import ja from './locales/ja-JP'
import {
  initLang,
  getLang
} from './lang'

Vue.use(VueI18n)

const messages = {
  'zh-CN': zh,
  'ja-JP': ja,
  'en-US': en
}

const langType = initLang()

export default new VueI18n({
  locale: langType,
  messages,
  dateTimeFormats
})

export {
  getLang
}
